export const TRIAL_API =
  'https://raw.githubusercontent.com/yalla-coop/curenetics/master/src/dummydata/Results-12-10-19.json';
